import { $$ } from '../../../shared/js/utils/dom';
import { Lightbox } from '../../../shared/js/modules/lightbox/Lightbox';
import { de } from '../../../shared/js/modules/lightbox/lang/de';

const galleries = $$('.gallery');
const galleryInstances = [];

class Gallery {
  constructor(params) {
    this.gallery = params.gallery;
    this.items = $$('.gallery-list__item', this.gallery);
    this.toggle = this.items.map(item =>
      item.querySelector('.gallery__lightbox-toggle')
    );
    this.lightboxInstance = undefined;
    this.labels = this.localization();
  }

  init = () => {
    this.setupLightbox();
  };

  localization = () => {
    const lang = document.documentElement.lang;
    const isGerman =
      lang === 'de' || !!document.documentElement.lang.match(/^de-/g);
    if (isGerman) {
      return de;
    }
    return {};
  };

  setupLightbox() {
    this.lightboxInstance = new Lightbox({
      gallery: this.gallery,
      children: this.toggle,
      zoom: false,
      mainClass: 'pswp--ifif',
      bgOpacity: 1,
      padding: { top: 100, bottom: 100 },
      closeSVG: `
        <span class="icon icon--cross">
          <svg class="icon__svg" focusable="false" role="img" aria-hidden="true">
            <use href="#icon-cross"></use>
          </svg>
          <span class="sr-only">${this.labels.closeTitle}</span>
        </span>
      `,
      arrowPrevSVG: `
        <span class="icon icon--chevron-right">
          <svg class="icon__svg" focusable="false" role="img" aria-hidden="true">
            <use href="#icon-chevron-right"></use>
          </svg>
          <span class="sr-only">${this.labels.arrowPrevTitle}</span>
        </span>
      `,
      arrowNextSVG: `
        <span class="icon icon--chevron-right">
          <svg class="icon__svg" focusable="false" role="img" aria-hidden="true">
            <use href="#icon-chevron-right"></use>
          </svg>
          <span class="sr-only">${this.labels.arrowNextTitle}</span>
        </span>
      `,
      preloaderSVG: `
        <div class="spinner">
          <svg class="spinner__icon pswp__icn" viewbox="0 0 66 66" focusable="false" role="img">
            <title>Spinner</title>
            <circle fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
          </svg>
          <span class="sr-only">Inhalte werden geladen ...</span>
        </div>
      `,
      // Custom props apart from Photoswipe API
      disableOnClickZoom: true,
      appendUIElementsToBottom: ['counter', 'arrowPrev', 'arrowNext'],
      defaultDialogTitle: 'Galerie Detailansicht',
      alignCopyrightWithImage: true,
    });

    this.lightboxInstance.init();
  }
}

// General Shower setup
galleries.forEach(gallery => {
  const galleryInstance = new Gallery({
    gallery,
  });
  galleryInstance.init();
  galleryInstances.push(galleryInstance);
});
